import { useEffect, useRef } from "react";

const singleton = (() => {
  const instance = {
    handleTouchMove: (e) => {
      // Allow scrolling on dialog content elements or multiline inputs
      if (
        e.target.closest &&
        (e.target.closest(".MuiDialogContent-root") ||
          e.target.closest(".MuiInputBase-inputMultiline"))
      ) {
        return;
      }
      e.preventDefault();
    },
    mainNode: document.body,
  };
  return () => instance;
})();

export const useModalScrollBlocker = ({ open, enabled = true }) => {
  const { handleTouchMove, mainNode } = singleton();
  const originalOverflowRef = useRef();

  useEffect(() => {
    if (!enabled) {
      mainNode.removeEventListener("touchmove", handleTouchMove);
      return;
    }

    if (!mainNode) return;

    if (open) {
      originalOverflowRef.current = mainNode.style.overflow;
      mainNode.style.overflow = "hidden";
      mainNode.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
    } else {
      mainNode.style.overflow = originalOverflowRef.current || "";
      mainNode.removeEventListener("touchmove", handleTouchMove);
    }

    return () => {
      if (enabled) {
        mainNode.style.overflow = originalOverflowRef.current || "";
        mainNode.removeEventListener("touchmove", handleTouchMove);
      }
    };
  }, [open, enabled, mainNode, handleTouchMove]);
};
